import AssignmentIcon from '@mui/icons-material/Assignment';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StepTemplate from 'FRONTEND/components/Calendar/AppointmentForm/StepTemplate';
import OtherAppointmentImage from 'FRONTEND/components/Calendar/AppointmentPreview/other_appointment.png';
import TeleconsultationImage from 'FRONTEND/components/Calendar/AppointmentPreview/teleconsultation.png';
import TelestaffImage from 'FRONTEND/components/Calendar/AppointmentPreview/telestaff.png';
import { getAppointmentTypeTranslationMap } from 'FRONTEND/components/Calendar/utils';
import { TilePicker } from 'FRONTEND/components/TilePicker/TilePicker';
import { pickType } from 'FRONTEND/reducers/bookingSlice';
import {
  BOOKABLE_APPOINTMENT_TYPE_LIST,
  OTHER, VIDEO_CONSULTATION, VIDEO_SPECIALIST_ASSESSMENT, BOOTH_TELECONSULTATION,
} from 'FRONTEND/utils/constants';
import i18n from 'FRONTEND/utils/i18n';

const ICONS_BY_TYPE = {
  [VIDEO_CONSULTATION]: <VideoCallIcon />,
  [VIDEO_SPECIALIST_ASSESSMENT]: <RecentActorsIcon />,
  [OTHER]: <AssignmentIcon />,
  [BOOTH_TELECONSULTATION]: <VideoCallIcon />,
};

export const IMAGE_BY_TYPE = {
  [VIDEO_CONSULTATION]: TeleconsultationImage,
  [VIDEO_SPECIALIST_ASSESSMENT]: TelestaffImage,
  [OTHER]: OtherAppointmentImage,
  [BOOTH_TELECONSULTATION]: TeleconsultationImage,
};

export const TypeStep = ({
  isCompleted,
  isLocked = false,
  onStepClick = () => {},
  shouldReset = false,
  onStepCompleted = () => {},
  typeList = BOOKABLE_APPOINTMENT_TYPE_LIST,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const selectedType = useSelector((state) => state.booking.selectedType);
  const isSmall = useSelector((state) => state.app.isSmall);

  useEffect(() => {
    if (shouldReset) {
      dispatch(pickType({ type: null }));
    }
  }, [shouldReset]);

  const handleTypeChange = (type) => {
    dispatch(pickType({ type }));
    onStepCompleted();
  };

  const buttonList = useMemo(() => {
    const translationMap = getAppointmentTypeTranslationMap();
    return typeList.map((type) => ({
      value: type,
      label: translationMap[type],
      icon: ICONS_BY_TYPE[type],
      backgroundImage: IMAGE_BY_TYPE[type],
    }));
  }, [typeList]);

  return (
    <StepTemplate
      label={i18n._('Select an appointment type')}
      isLocked={isLocked}
      tooltipText={i18n._('This is the only available appointment type for the selected practitioner')}
      onEditClick={() => onStepClick()}
      isStepCompleted={isCompleted}
      editText={getAppointmentTypeTranslationMap()[selectedType]}
      {...otherProps}
    >
      <TilePicker
        buttonList={buttonList}
        selectedValue={selectedType}
        onChange={handleTypeChange}
        isVertical={isSmall}
        emptyMessage={i18n._('This practitioner is not available for any type of appointment.')}
        className='appointmentForm-input'
      />
    </StepTemplate>
  );
};
